
const state = () => ({
    initialData: [],
    topupData: [],
    topupTotal: 0,
});

const getters = {
    topUpList(state){
        return state.topupData;
    },
    topUpTotal(state){
        return state.topupTotal;
    }
};

const actions = {
    addTopup({commit,state,dispatch},data){

        commit("addTopup",data);

        localStorage.setItem("topup",JSON.stringify(state.topupData));

        localStorage.removeItem("topuptotal")

        const calculateData = {
            amount: data.amount,
            action: "adding"
        }

        dispatch("calculateTotal",calculateData)
    },
    deleteTopup({commit,state,dispatch},data){

        const topupdata = JSON.parse(localStorage.getItem("topup"));

        const remaindata = topupdata.filter((result,index) => index != data.id);

        localStorage.removeItem("topup");

        commit("deleteTopup",remaindata);

        localStorage.setItem("topup",JSON.stringify(state.topupData));
        
        localStorage.removeItem("topuptotal");

        let totalamount = 0;

        remaindata.forEach(data => {
            totalamount = totalamount + parseInt(data.amount);
        });
        console.log(totalamount);

        const calculateData = {
            amount: totalamount,
            action: "deleting"
        }

        dispatch("calculateTotal",calculateData)
    },
    clearAll({commit}){
        localStorage.removeItem("topup");

        localStorage.removeItem("topuptotal");

        commit("clearingAll");

    },
    calculateTotal({commit,state},data){

        if (data.action === "adding") {
            commit("addingTotal",data.amount)
        }
        else if(data.action === "deleting"){
            console.log(data.amount)
            commit("deletingTotal",data.amount)
        }

        localStorage.setItem("topuptotal",state.topupTotal);
    },

};

const mutations = {
    addTopup(state,payload){ 
        state.topupData.push(payload)
    },
    deleteTopup(state,payload){
        state.topupData = payload
    },
    addingTotal(state,payload){
        state.topupTotal = state.topupTotal + parseInt(payload);
    },
    deletingTotal(state,payload){
        state.topupTotal = parseInt(payload);
    },
    clearingAll(state){
        state.topupData = [];

        state.topupTotal = 0;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}